/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Shared geographic eligibility rules for any platform surface gating prize eligibility. Promoted from the RTTR-shaped ChallengeEligibilityGeo so the same admin form + resolver covers Challenges / Campaigns / Quests / Competitions / Drops.
 * @export
 * @interface EligibilityConfig
 */
export interface EligibilityConfig {
    /**
     * ISO-3166-1 alpha-2 country codes (e.g. ["US"]) that participate fully (subject to per-state rules). Empty means no country gate at all.
     * @type {Array<string>}
     * @memberof EligibilityConfig
     */
    allowedCountries?: Array<string>;
    /**
     * U.S. state codes (e.g. ["CO","MD","NE","ND","VA"]) blocked from registration entirely. Modal refuses to submit; no membership is ever created.
     * @type {Array<string>}
     * @memberof EligibilityConfig
     */
    hardBlockStates?: Array<string>;
    /**
     * When true, U.S. territories (PR/GU/VI/AS/MP/UM) are blocked alongside hardBlockStates.
     * @type {boolean}
     * @memberof EligibilityConfig
     */
    hardBlockTerritories?: boolean;
    /**
     * U.S. state codes (e.g. ["NY","FL"]) that participate fully but cannot win prizes. Membership is created with status="prize-restricted".
     * @type {Array<string>}
     * @memberof EligibilityConfig
     */
    prizeRestrictedStates?: Array<string>;
    /**
     * When true, users from any country are admitted for bragging rights — countries outside allowedCountries are admitted with status="prize-restricted" instead of being 403'd at registration. When false (default) the legacy hard-block on non-allowed countries still applies.
     * @type {boolean}
     * @memberof EligibilityConfig
     */
    admitAllCountries?: boolean;
    /**
     * Optional URL to the Official Rules document. Surfaced as a "Read full rules" link in the eligibility section of the sign-in modal.
     * @type {string}
     * @memberof EligibilityConfig
     */
    officialRulesUrl?: string;
}

/**
 * Check if a given object implements the EligibilityConfig interface.
 */
export function instanceOfEligibilityConfig(value: object): value is EligibilityConfig {
    return true;
}

export function EligibilityConfigFromJSON(json: any): EligibilityConfig {
    return EligibilityConfigFromJSONTyped(json, false);
}

export function EligibilityConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedCountries': json['allowedCountries'] == null ? undefined : json['allowedCountries'],
        'hardBlockStates': json['hardBlockStates'] == null ? undefined : json['hardBlockStates'],
        'hardBlockTerritories': json['hardBlockTerritories'] == null ? undefined : json['hardBlockTerritories'],
        'prizeRestrictedStates': json['prizeRestrictedStates'] == null ? undefined : json['prizeRestrictedStates'],
        'admitAllCountries': json['admitAllCountries'] == null ? undefined : json['admitAllCountries'],
        'officialRulesUrl': json['officialRulesUrl'] == null ? undefined : json['officialRulesUrl'],
    };
}

export function EligibilityConfigToJSON(json: any): EligibilityConfig {
    return EligibilityConfigToJSONTyped(json, false);
}

export function EligibilityConfigToJSONTyped(value?: EligibilityConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedCountries': value['allowedCountries'],
        'hardBlockStates': value['hardBlockStates'],
        'hardBlockTerritories': value['hardBlockTerritories'],
        'prizeRestrictedStates': value['prizeRestrictedStates'],
        'admitAllCountries': value['admitAllCountries'],
        'officialRulesUrl': value['officialRulesUrl'],
    };
}

